import{jsx as e,jsxs as r}from"react/jsx-runtime";import{ButtonIcon as o}from"@vds-core/button-icons";import{Icon as n}from"@vds-core/icons";import{hexToRgba as t,calculateRem as i,generateUUID as a}from"@vds-core/utilities";import{AccessibilityTokens as s}from"@vds-tokens/accessibility";import{ColorTokens as d}from"@vds-tokens/color";import{LayoutTokens as u}from"@vds-tokens/layout";import{useState as l,useEffect as c}from"react";import p from"styled-components";const b=d.palette.gray44.value,m=d.background.primary.inverse.dark.value,g=d.elements.primary.ondark.value,h=p.div.withConfig({displayName:"VolumeWrapper",componentId:"VDS__sc-1y2zg2h-0"})`
  align-items: center;
  border-radius: 24px;
  bottom: 0px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 148px;
  justify-content: flex-end;
  position: absolute;
  z-index: 1;
  background-color: transparent;
  input {
    &::-webkit-slider-thumb {
      display: block;
      box-shadow:
        0px 1px 11px 0px ${t(d.palette.black.value,.12)},
        0px 3px 5px 0px ${t(d.palette.black.value,.05)};
    }
  }
  &:hover {
    > div {
      background-color: ${d.background.secondary.dark.value};
      transition: background-color 200ms linear;
    }
    label {
      opacity: 1;
      transition: opacity 200ms linear;
    }
    button,
    button:active {
      background: transparent;
      box-shadow: none;
    }
  }
  ${function({volumeButtonFocused:e}){return!e&&`\n  &:has(:focus-visible) {\n    background-color: ${d.background.secondary.dark.value};\n    > label{\n      opacity: 1;\n    }\n    > div {\n      background-color: ${d.background.secondary.dark.value};\n      transition: background-color 200ms linear;\n    }\n    input {\n      &::-webkit-slider-thumb {\n        display: block;\n      }\n    }\n  }`}}
  &:focus-within {
    input {
      &::-webkit-slider-thumb {
        display: block;
      }
    }
  }
`,k=p.label.withConfig({displayName:"VolumeSliderWrapper",componentId:"VDS__sc-1y2zg2h-1"})`
  align-items: center;
  background-color: ${d.background.secondary.dark.value};
  border-radius: ${u.shape.cornerradius.circle.value}
    ${u.shape.cornerradius.circle.value} 0 0;
  display: flex;
  flex-direction: row;
  height: 100%;
  opacity: 0;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 44px;
  transition: opacity 200ms linear 200ms;
  &:hover {
    input {
      &::-webkit-slider-thumb {
        display: block;
      }
    }
  }
  &:focus-within {
    input {
      &::-webkit-slider-thumb {
        display: block;
      }
    }
  }
  &:has(:focus-visible) {
    overflow: visible;
  }
`,x=p.progress.withConfig({displayName:"Progress",componentId:"VDS__sc-1y2zg2h-2"})`
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 2px;
  bottom: 4px;
  height: 4px;
  margin: auto 0px;
  pointer-events: none;
  position: absolute;
  top: 20px;
  transform: rotate(-90deg);
  width: 80px;

  &::-webkit-progress-bar {
    background-color: ${b};
    border-radius: 4px;
  }
  &::-webkit-progress-value {
    background: ${m};
    border-radius: 4px;
  }
  &::-moz-progress-bar {
    background: ${b};
  }
`,v=p.div.withConfig({displayName:"VolumeButtonWrapper",componentId:"VDS__sc-1y2zg2h-3"})`
  border-radius: 0 0 50% 50%;
  transition: background-color 200ms linear 200ms;
`,f=p.input.withConfig({displayName:"VolumeSlider",componentId:"VDS__sc-1y2zg2h-4"})`
  -moz-appearance: none;
  -webkit-appearance: none;
  background: transparent;
  border-radius: 4px;
  bottom: 4px;
  box-sizing: border-box;
  cursor: pointer;
  height: 4px;
  margin: auto 0px;
  padding: 0px;
  position: absolute;
  top: 20px;
  transform: rotate(-90deg);
  width: 80px;
  &::after {
    content: '';
    position: absolute;
    top: -20px;
    bottom: -20px;
    width: 100%;
  }

  &:focus-visible {
    outline: ${i(s.focusring.borderwidth.value)}
      ${s.focusring.borderstyle.value}
      ${s.color.focusring.ondark.value};
    outline-offset: ${u.space["2X"].value};
  }
  &:focus {
    &::-webkit-slider-runnable-track {
      background: transparent;
    }
  }
  &::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    border-radius: 1.3px;
    cursor: pointer;
    height: 12px;
    transition: all 0.4s ease;
    width: 80px;
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: ${g};
    border-radius: 16px;
    cursor: pointer;
    display: none;
    height: 12px;
    width: 12px;
  }

  &::-moz-range-track {
    background: transparent;
    border: 1px solid transparent;
    cursor: pointer;
    height: 4px;
    width: 100%;
  }
  &::-moz-range-thumb {
    background: ${g};
    border-radius: 50px;
    cursor: pointer;
    height: 12px;
    width: 12px;
  }
  &:focus {
    input {
      &::-webkit-slider-thumb {
        display: block;
      }
    }
  }
`,y=function({onChangeMuted:t,muted:i,onChangeVolume:s,volume:d,ariaLabel:u}){const[p]=l(a()),[b,m]=l(!1),g=`button-${p}`;return c((function(){const e=document.getElementById(g),r=function(){return m(!0)};null==e||e.addEventListener("focus",r);const o=function(){return m(!1)};return null==e||e.addEventListener("blur",o),function(){null==e||e.removeEventListener("focus",r),null==e||e.removeEventListener("blur",o)}}),[]),e("div",{style:{width:"44px"},children:r(h,{volumeButtonFocused:b,children:[r(k,{"aria-hidden":"true","aria-atomic":"true",htmlFor:p,children:[e(x,{max:1,value:d,"aria-hidden":"true"}),e(f,{onKeyDown:s,min:0,type:"range",max:1,step:"any",onChange:s,value:d,"aria-atomic":"true","aria-label":`${u} Volume`,id:p})]}),e(v,{"aria-live":"polite","aria-atomic":"true","aria-relevant":"additions",children:e(o,{focusBorderPosition:"outside",size:"large",kind:"ghost",surface:"dark",onClick:t,ariaLabel:i?`${u} unmute`:`${u} mute`,id:g,"data-testid":"mute-control",renderIcon:function(r){return e(n,i?Object.assign({name:"speaker-mute"},r,{ariaHidden:!0,size:"large"}):Object.assign({name:"speaker-phone"},r,{ariaHidden:!0,size:"large"}))}})})]})})};export{y as default};
